import React from 'react'
import { motion } from 'framer-motion'
import { capitalizeFirst } from '../../lib/stringOperations'

const hoverMotion = {
    rest: {
        backgroundColor: '#fff'
    },
    hover: {
        backgroundColor: '#e6f7ff',
        borderRadius: 5
    }
}

const styles = {
    row: {
        textAlign: 'start',
        cursor: 'pointer',
        borderRadius: 10
    },
    result: {
        display: 'flex',
        flexDirection: 'column',
        lineHeight: '20px',
        padding: 10
    }
}

const Suggestions = ({ data, onSelect }) => {
    return (
        data.map(item => {
            return (
                <motion.div
                    key={item.pk}
                    style={styles.row}
                    onClick={() => onSelect(item)}
                    initial={null}
                    whileHover="hover" animate="rest"
                    variants={hoverMotion}
                >
                    <div style={styles.result}>
                        <div>
                            <strong>{capitalizeFirst(item.firstName)} {capitalizeFirst(item.lastName)}</strong>
                        </div>
                        <small>{item.email}</small>
                    </div>

                </motion.div>
            )
        })
    )
}

export default Suggestions